module.exports = __webpack_public_path__ + "static/media/decade-grid-4.f0014347.png";